// removed by extract-text-webpack-plugin
module.exports = {"root":"_3m1-_","postList":"_1DArf","contentBlockRoot":"_Un5Ov","contentBlock":"_heSaw","title":"_3SPil","content":"_2vau-","tagBlock":"_2tEcb"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/Post/components/PostContent/components/ContentBlock/ContentBlock.scss
// module id = 1187
// module chunks = 2